import {NgIf} from '@angular/common';
import {Component, Input, ViewEncapsulation} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import {Q9DefaultValueAccessor} from '@q9elements/ui-kit/common';
import {IconButtonComponent} from '@q9elements/ui-kit/components';

@Component({
  standalone: true,
  selector: 'q9ma-password-control',
  templateUrl: './password-control.component.html',
  styleUrls: ['./password-control.component.scss'],
  imports: [
    MatInputModule,
    IconButtonComponent,
    TranslateModule,
    NgIf,
    FormsModule,
    ReactiveFormsModule
  ],
  encapsulation: ViewEncapsulation.None
})
export class PasswordControlComponent extends Q9DefaultValueAccessor {
  @Input() showPassword = false;
  @Input() error: string;
  @Input() placeholder = 'SIGNUP.PASSWORD_PLACEHOLDER';
  @Input() label = 'SIGNUP.PASS';
  @Input() isRequired: boolean;
  @Input() isLoginFlow = false;
  @Input() disabled: boolean = false;
}
